import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../Seo';

import flags from '../../images/battle-map/cannon2.png';

const LoadingMsg = [''];
class PreLoader extends React.Component {
  render() {
    return (
      <>
        <SEO
          title="George Washington: An Interactive Map of His Key Military Battles"
          description="Explore the epic battles that made him into a legendary general—and led to American freedom."
          image="https://cropper.watch.aetnd.com/cdn.watch.aetnd.com/sites/2/2020/02/gw.map_.promo_.jpg"
          author="@history"
          url="https://www.history.com/george-washington-battle-map-american-revolution/index.html"
        />
        <motion.div className="preLoader">
          <div className="loading_header_map">George Washington:</div>
          <div className="loading_sub">
            An Interactive Map of His Key Military Battles
          </div>
          <br /> <br /> <br />
          <img src={flags} style={{ width: '300px', height: 'auto' }} />
          <motion.p
            className="loadingTxt"
            style={{ textAlign: 'center', color: '#bec9d7' }}
            animate={{
              opacity: [0, 1, 0, 1, 0],
            }}
            transition={{ duration: 3 }}
            onAnimationComplete={this.props.onComplete}
          >
            Loading for Battle
          </motion.p>
        </motion.div>
      </>
    );
  }
}

export default PreLoader;
